import React, { Fragment, useState, useEffect } from "react";
import { Tab } from "@headlessui/react";
import DropDownComponent from "./metadataDropDownList";
import QuestionStatistics from "./questionStatistics";
import { IStandard } from "../../../model/interface/standard";
import {
  IAssociatedPassages,
  IAssociatedVideos,
  IQuestion,
} from "../../../model/interface/question";
import QuestionTypeSelect from "./questionTypeSelect";
import { ITag } from "../../../model/interface/tag";
import Select from "react-select";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import constant from "../../../utils/constant";
import { useNavigate } from "react-router";
import { validateExternalSourceId } from "../../../api/question.service";
import { toast } from "react-toastify";
import QuestionStandard from "./questionStandard";
import TeacherFeedback from "./teacherFeedback";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import DelinkStandardPopup from "../../shared/common/delinkStandardPopup";
import {
  EXTERNAL_SOURCE_TYPES,
  UGA_EXTERNAL_SOURCE_TYPE_ID,
} from "./constants";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const defaultState = {
  label: "None",
  value: 0,
};
const AuthorQuestionTabs = ({
  dropV,
  setWidget,
  questionId,
  setQuestionId,
  setpayloadLabel,
  getQuestionTypePayloadSchema,
  setStateId,
  setSubjectId,
  SetDomainId,
  SetStandardId,
  SetDOKId,
  setIsPublished,
  setIsAIAssisted,
  setQuestionTypeId,
  createQuestion,
  selectedStateId,
  selectedSubjectId,
  selectedDomainId,
  questionEditData,
  editFlag,
  copyFlag,
  isPublished,
  isAIAssisted,
  isDiagnostics,
  setIsDiagnostics,
  language,
  setExternalSourceTypeId,
  setExternalSourceId,
  externalSourceTypeId,
  externalSourceId,
  getQuestionTag,
  editSelectedTags,
  associatedPassageIds,
  associatedPassage,
  classification,
  setClassification,
  handleSaveTags,
  handleRemoveTag,
  selectedTagIds,
  associatedVideoIds,
  associatedPassageClassification,
  associateStandardId,
  associateStandardName,
  associateStandardData,
  unLinkedStandardId,
  setShowSetAnswerErrorEnglish,
  setShowSetAnswerErrorSpanish,
  setIsMachineTranslated,
  isMachineTranslated,
  esTranslationDone,
  contentAreadId,
  gradeLevel,
}: // props,
{
  dropV: any;
  setWidget: any;
  questionId: any;
  setQuestionId: any;
  setpayloadLabel: any;
  getQuestionTypePayloadSchema: any;
  setStateId: any;
  setSubjectId: any;
  SetDomainId: any;
  SetStandardId: any;
  SetDOKId: any;
  setIsPublished: any;
  setIsAIAssisted: any;
  setQuestionTypeId: any;
  createQuestion: any;
  selectedStateId: any;
  selectedSubjectId: any;
  selectedDomainId: any;
  questionEditData: IQuestion;
  editFlag: boolean;
  copyFlag: boolean;
  isPublished: boolean;
  isAIAssisted: boolean;
  isDiagnostics: boolean;
  setIsDiagnostics: any;
  language: any;
  setExternalSourceTypeId: any;
  setExternalSourceId: any;
  externalSourceTypeId: number | undefined;
  externalSourceId: string;
  getQuestionTag;
  editSelectedTags: any;
  associatedPassageIds: IAssociatedPassages | undefined;
  associatedPassage: ISelectElement[] | undefined;
  classification: number | undefined;
  setClassification: any;
  handleSaveTags;
  handleRemoveTag;
  selectedTagIds;
  associatedVideoIds: IAssociatedVideos | undefined;
  associatedPassageClassification: string | undefined;
  associateStandardId: any;
  associateStandardName: any;
  associateStandardData: any;
  unLinkedStandardId: any;
  setShowSetAnswerErrorEnglish: any;
  setShowSetAnswerErrorSpanish: any;
  setIsMachineTranslated: any;
  isMachineTranslated: boolean;
  esTranslationDone: boolean;
  contentAreadId: number;
  gradeLevel: string;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(99999);
  const [stateSubjects, setStateSubjects] = useState([]);
  const [state, setState] = useState([]);
  const [domain, setDomain] = useState([]);
  const [standard, setStandard] = useState([]);
  const [questionClassification, setQuestionClassification] = useState([]);
  const [enableDisableStates, setEnableDisableStates] = useState<boolean>(true);
  const [enableDisableSubjects, setEnableDisableSubjects] =
    useState<boolean>(true);
  const [enableDisableDomains, setEnableDisableDomains] =
    useState<boolean>(true);
  const [enableDisableStandards, setEnableDisableStandards] =
    useState<boolean>(true);
  const defaultValue = { label: null, value: "0" };
  const defaultElement = [{ label: "Select", value: "0" }];
  const [questionTag, setQuestionTag] = useState<ISelectElement[]>([]);
  const [selectedQuestionTag, setSelectedQuestionTag] = useState(defaultValue);
  const [selectstateSubjects, setselectStateSubjects] = useState<any>();
  const [selectstate, setselectState] = useState<any>(defaultState);
  const [selectdomain, setselectDomain] = useState<any>();
  const [selectstandard, setselectStandard] = useState<any>();
  const [selectDok, setselectDok] = useState<any>();
  const [isApproved, setisApproved] = useState<boolean>(true);
  const [isActive, setisActive] = useState<boolean>(true);
  const [items, setItems] = useState<any>([]);
  const [tags, setTags] = useState<ITag[]>([]);
  const [selectedTags, setSelectedTags] =
    useState<Array<ISelectElement>>(editSelectedTags);
  const [selectedClassification, setSelectedClassification] =
    useState(defaultValue);
  const [allTags, setAllTags] = useState<Array<any>>([]);
  const navigate = useNavigate();
  const [reloadStandards, setReloadStandards] = useState<boolean>(false);
  const [standardToDelink, setStandardToDelink] = useState<number>(0);
  const [isDelink, setIsDelink] = useState<boolean>(false);
  const [showLinkedStandards, setShowLinkedStandards] =
    useState<boolean>(false);
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const [questionFeedbackCount, setQuestionFeedback] = useState<number>(0);
  const handleQuestionTypeChange = (e) => {
    dropV(e.data.externalCode);
    setpayloadLabel(e.data.questionCategoryName + "-" + e.data.name);
    setShowSetAnswerErrorEnglish(false);
    setShowSetAnswerErrorSpanish(false);
    if (questionId === "" || questionId === undefined) {
      getQuestionTypePayloadSchema(e.data.externalCode);
    } else {
      setWidget(
        e.data.externalCode,
        e.data.questionCategoryName + "-" + e.data.name
      );
    }
    setEnableDisableStates(false);
    setQuestionTypeId(e.data.questionTypeId);

    const dropOption: any = [];
    dropOption.push(defaultState);

    state.map((values: any) => {
      dropOption.push({
        label: values?.name,
        value: values?.stateId,
      });
    });
    setItems(dropOption);
  };

  const handleExternalSourceIdChange = (e) => {
    setExternalSourceId(e.target.value);
  };

  const validateExternalSourceIdChange = () => {
    let isValid = false;
    if (externalSourceId.length > 0) {
      validateExternalSourceId(
        externalSourceId,
        externalSourceTypeId,
        questionId
      )
        .then((r) => {
          isValid = r.data;
          if (!isValid) {
            setExternalSourceId("");
            toast.info(
              "ExternalSourceId(" + externalSourceId + ") already exists."
            );
          }
        })
        .catch((err) => {
          toast.error("Error while validating the ID");
        });
    }
  };

  const handleExternalSourceTypeIdChange = (e) => {
    if (e) setExternalSourceTypeId(e.value);
    else {
      setExternalSourceTypeId(0);
      setExternalSourceId("");
    }
  };

  const handleQuestionClassificationChange = (e) => {
    setClassification(undefined);
    if (e) {
      setClassification(e.value);
      setSelectedClassification(e);
    }
  };

  const subjectByStateId = () => {
    async function subjectReload() {
      if (associateStandardData) {
        setEnableDisableSubjects(false);
        setEnableDisableDomains(false);
        setEnableDisableStandards(false);
      }
      setLoading(true);

      const service = await import("../../../api/subject.service");
      const response = service.getSubjectByState(
        pageSize,
        pageNumber,
        selectedStateId,
        isActive,
        isApproved
      );
      const data = (await response).data;
      const dropOption = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.subjectId,
        };
      });
      setStateSubjects(dropOption);
      setLoading(false);
    }
    if (editFlag || copyFlag || associateStandardData) {
      let dropOption = {};
      dropOption = {
        label:
          questionEditData?.subjectName || associateStandardData?.subjectName,
        value: questionEditData?.subjectId || associateStandardData?.subjectId,
      };
      setselectStateSubjects(dropOption);
    }
    if (editFlag || copyFlag) {
      let dropOption = {};
      dropOption = {
        label: questionEditData?.stateName,
        value: questionEditData?.stateId,
      };
      setselectState(dropOption);
    }
    subjectReload();
  };

  const domainBySubjectId = async () => {
    const service = await import("../../../api/domain.service");
    service
      .getAllDomainsBySubject(selectedSubjectId, pageSize, pageNumber)
      .then((res) => {
        const dropOption = res.data.data.map((values: any) => {
          return {
            label: values?.name,
            value: values?.domainId,
          };
        });
        setDomain(dropOption);
      });
    if (editFlag || copyFlag || associateStandardData) {
      let dropOption = {};
      dropOption = {
        label:
          questionEditData?.domainName || associateStandardData?.domainName,
        value: questionEditData?.domainId || associateStandardData?.domainId,
      };
      setselectDomain(dropOption);
    }
    if (editFlag || copyFlag) {
      let dropOption = {};
      dropOption = {
        label: constant.DOK.filter(
          (item) => item.value === questionEditData?.dok
        )[0]?.label,
        value: questionEditData?.dok,
      };
      setselectDok(dropOption);
    }
  };

  const standardByDomainId = async () => {
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: selectedDomainId,
      code: "",
      isActive: true,
      isApproved: true,
      description: "",
      loadOrder: 0,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    const service = await import("../../../api/standard.service");
    service.getStandards(standard).then((response: any) => {
      const dropOption = response.data.data.map((values: any) => {
        return {
          label: `[${values?.code}] ${values?.name}`,
          value: values?.standardId,
        };
      });
      setStandard(dropOption);
    });
    if (questionEditData || associateStandardData) {
      let dropOption = {};
      dropOption = {
        label: `[${
          questionEditData?.standardCode ||
          associateStandardData?.code ||
          associateStandardData?.standardCode
        }] ${
          questionEditData?.standardName ||
          associateStandardData?.name ||
          associateStandardData?.standardName
        }`,
        value:
          questionEditData?.standardId || associateStandardData?.standardId,
      };
      setselectStandard(dropOption);
    }
  };

  const questionStatistics: IQuestion = {
    createdByUserId:
      editFlag && questionEditData.createdByUserId
        ? questionEditData.createdByUserId
        : 0,
    createdBy:
      editFlag && questionEditData.createdBy ? questionEditData.createdBy : "",
    updatedBy:
      editFlag && questionEditData.updatedBy ? questionEditData.updatedBy : "",
    updatedDate:
      editFlag && questionEditData.updatedDate
        ? questionEditData.updatedDate
        : undefined,
    statistics: {
      answered:
        editFlag &&
        questionEditData.statistics &&
        questionEditData.statistics.answered
          ? questionEditData.statistics.answered
          : 0,
      answeredCorrectly:
        editFlag &&
        questionEditData.statistics &&
        questionEditData.statistics.answeredCorrectly
          ? questionEditData.statistics.answeredCorrectly
          : 0,
      percentCorrect:
        editFlag &&
        questionEditData.statistics &&
        questionEditData.statistics.percentCorrect
          ? questionEditData.statistics.percentCorrect
          : 0,
      feedbackCount:
        editFlag &&
        questionEditData.statistics &&
        questionEditData.statistics.feedbackCount
          ? questionEditData.statistics.feedbackCount
          : 0,
      assessmentCount:
        editFlag &&
        questionEditData.statistics &&
        questionEditData.statistics.assessmentCount
          ? questionEditData.statistics.assessmentCount
          : 0,
    },
  };

  async function bindAllTag(editedPassage) {
    const service = await import("../../../api/passage.service");
    service.getAllTags().then((response) => {
      let newQuestionTag = [];
      if (response.data.data?.length > 0) {
        setAllTags(response.data.data);
        newQuestionTag = response.data?.data.map((element) => {
          return {
            value: element.tagId || 0,
            label: `${element.name}`,
            contentAreaId: `${element.contentAreaId}`,
            contentAreaName: `${element.contentAreaName}`,
            categoryId: `${element.categoryId}`,
            categoryName: `${element.categoryName}`,
            description: `${element.description}`,
            isActive: `${element.isActive}`,
            color: `${element.color}`,
            userId: `${element.userId}`,
          };
        });
        if (editedPassage === "") {
          setSelectedQuestionTag(defaultValue);
        } else {
          const assignedValue = response.data?.data.filter(
            (thisData) =>
              thisData.tagId === editedPassage.passageCategoryOldTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0].tagId,
            label: assignedValue[0].name,
          };
          setSelectedQuestionTag(dropdownInitializer);
        }
      }
      if (editSelectedTags?.length) {
        const selectedTagItems: any = [];
        editSelectedTags.map((ds, i) => {
          const filterTag: any = newQuestionTag.filter(
            (tag: any) => tag.value == ds.value
          );
          if (filterTag.length) {
            selectedTagItems.push(filterTag[0]);
          }
        });
        setSelectedTags(selectedTagItems);
      }
      setQuestionTag(newQuestionTag);
    });
  }

  async function bindQuestionClassification() {
    const service = await import("../../../api/question.service");
    service.getClassifications().then((response: any) => {
      const dropOption = response.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.questionClassificationId,
        };
      });
      setQuestionClassification(dropOption);
      if (editFlag && questionEditData) {
        const assignedValue = response.data?.filter(
          (thisData) =>
            thisData.questionClassificationId ===
            questionEditData.questionClassificationId
        );
        const dropdownInitializer = {
          value: assignedValue[0]?.questionClassificationId,
          label: assignedValue[0]?.name,
        };
        setSelectedClassification(dropdownInitializer);
        setClassification(dropdownInitializer.value);
      } else if (copyFlag && classification) {
        const assignedValue = response.data?.filter(
          (thisData) => thisData.questionClassificationId === classification
        );
        const dropdownInitializer = {
          value: assignedValue[0]?.questionClassificationId,
          label: assignedValue[0]?.name,
        };
        setSelectedClassification(dropdownInitializer);
        setClassification(dropdownInitializer.value);
      } else if (associatedVideoIds && associatedVideoIds.length > 0) {
        const assignedValue = response.data?.filter(
          (thisData) => thisData.name === "Video"
        );
        const dropdownInitializer = {
          value: assignedValue[0]?.questionClassificationId,
          label: assignedValue[0]?.name,
        };
        setSelectedClassification(dropdownInitializer);
        setClassification(dropdownInitializer.value);
      } else if (
        associatedPassageIds &&
        associatedPassageIds.length > 0 &&
        associatedPassageClassification
      ) {
        const assignedValue = response.data?.filter(
          (thisData) => thisData.name === associatedPassageClassification
        );
        const dropdownInitializer = {
          value: assignedValue[0]?.questionClassificationId,
          label: assignedValue[0]?.name,
        };
        setSelectedClassification(dropdownInitializer);
        setClassification(dropdownInitializer.value);
      }
    });
  }

  useEffect(() => {
    bindAllTag("");
    bindQuestionClassification();
  }, []);

  useEffect(() => {
    bindQuestionClassification();
  }, [editFlag, copyFlag]);

  useEffect(() => {
    bindAllTag("");
  }, [editSelectedTags]);

  useEffect(() => {
    const dropOption: any = [];
    dropOption.push(defaultState);

    state.map((values: any) => {
      dropOption.push({
        label: values?.name,
        value: values?.stateId,
      });
    });
    setItems(dropOption);
    setLoading(true);
    stateDataReload();
    if (selectedStateId || associateStandardId || selectedSubjectId) {
      subjectByStateId();
    }
    if (selectedSubjectId || associateStandardId) {
      domainBySubjectId();
    }
    if (selectedDomainId != "" || associateStandardId) {
      standardByDomainId();
    }

    setLoading(false);
  }, [
    pageSize,
    pageNumber,
    selectedStateId,
    selectedSubjectId,
    selectedDomainId,
    copyFlag,
  ]);

  const stateDataReload = () => {
    async function stateReload() {
      setLoading(true);
      const service = await import("../../../api/subject.service");
      const response = service.getStateAll(pageSize, pageNumber);
      const data = (await response).data;
      setState(data.data);
      setLoading(false);
    }
    stateReload();
  };
  function redirectToPassageDetail(passageId) {
    navigate(constant.EDITPASSAGE?.replace(":id", passageId.toString()), {
      state: { objectToEdit: passageId },
    });
  }
  function redirectToVideoDetail(videoId) {
    navigate(constant.VIDEOEDIT?.replace(":id", videoId.toString()));
  }

  const handleDelinkConfirmation = (action: boolean, standardId: number) => {
    if (action) {
      setIsDelink(false);

      deleteQuestionStandardAssociation(standardId);
    } else {
      setIsDelink(false);
    }
  };

  const deleteQuestionStandardAssociation = async (standardId: number) => {
    setLoading(true);
    setStandardToDelink(standardId);
    const service = await import("../../../api/question.service");
    await service.deleteAssociatedQuestions({
      standardId: standardId,
      questionIds: questionId,
    });
    setLoading(false);
    toast.success("Associated standard deleted successfully");
    setReloadStandards(true);
  };

  const updateQuestionFeedbackCount = (questionFeedbackCount: number) => {
    setQuestionFeedback(questionFeedbackCount);
  };

  useEffect(() => {
    const tags: any = [];
    selectedTagIds.map((id) => {
      const tag = allTags.filter((ds) => ds.tagId === id);
      if (tag.length) {
        tags.push(tag[0]);
      }
    });
    getQuestionTag(tags);
  }, [selectedTagIds, allTags]);

  useEffect(() => {
    if (!esTranslationDone && !editFlag) {
      setIsMachineTranslated(isPublished);
    }
  }, [isPublished, esTranslationDone]);
  useEffect(() => {
    if (esTranslationDone) {
      setIsMachineTranslated(!esTranslationDone);
    }
  }, [esTranslationDone]);

  // Saved value, not the externalSourceTypeId prop: that one tracks the External Source
  // dropdown, and dropping a tab mid-edit shifts the Headless UI index under the user.
  const showStandardSearchTab =
    editFlag &&
    questionEditData?.externalSource?.externalSourceTypeId !==
      UGA_EXTERNAL_SOURCE_TYPE_ID;

  return (
    <Tab.Group>
      <Tab.List className="bg-gray-100 w-full">
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={classNames(
                selected
                  ? "text-gray-900 topBorder bg-white border border-b-0"
                  : "text-gray-500 hover:text-gray-700 ",
                "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
              )}
            >
              Metadata
            </button>
          )}
        </Tab>
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={classNames(
                selected
                  ? "text-gray-900 topBorder border border-b-0 bg-white"
                  : "text-gray-500 hover:text-gray-700 ",
                "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50  focus:z-10"
              )}
            >
              Statistics
            </button>
          )}
        </Tab>
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={classNames(
                selected
                  ? "text-gray-900 topBorder border border-b-0 bg-white"
                  : "text-gray-500 hover:text-gray-700 ",
                "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
              )}
            >
              Tags
            </button>
          )}
        </Tab>
        {showStandardSearchTab && (
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={classNames(
                  selected
                    ? "text-gray-900 topBorder border border-b-0 bg-white"
                    : "text-gray-500 hover:text-gray-700 ",
                  "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                )}
              >
                Standard Search
              </button>
            )}
          </Tab>
        )}
        {editFlag && (
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={classNames(
                  selected
                    ? "text-gray-900 topBorder border border-b-0 bg-white"
                    : "text-gray-500 hover:text-gray-700 ",
                  "group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                )}
              >
                Question Feedback
                <p className="ml-2 inline-block bg-yellow-400 rounded-full text-xs shadow-sm py-0.5 px-3 ">
                  {questionFeedbackCount}
                </p>
              </button>
            )}
          </Tab>
        )}
      </Tab.List>
      <Tab.Panels>
        <Tab.Panel
          className={classNames(
            " text-gray-900",
            "block px-4 py-4 text-sm shadow border-b border-gray-200 sm:rounded-b-lg"
          )}
        >
          <div>
            <div className={"grid grid-cols-12 gap-5"}>
              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1">Question Type</div>
                <div className="text-sm">
                  <QuestionTypeSelect
                    languages={language}
                    onChange={handleQuestionTypeChange}
                    value={
                      editFlag || copyFlag ? questionEditData.questionTypeId : 0
                    }
                    isEdit={editFlag || copyFlag}
                    getQuestionTypePayloadSchema={getQuestionTypePayloadSchema}
                  ></QuestionTypeSelect>
                </div>
              </div>

              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1"> State</div>
                <div className="text-sm">
                  <DropDownComponent
                    dropName={"state"}
                    dropValue={items}
                    defaultValue={
                      editFlag || copyFlag ? selectstate : defaultState
                    }
                    dropSelect={setStateId}
                    disabled={
                      editFlag || copyFlag ? false : enableDisableStates
                    }
                    enableDisableSubjects={setEnableDisableSubjects}
                    languages={language}
                  ></DropDownComponent>
                </div>
              </div>

              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1"> Subject</div>
                <div className="text-sm">
                  <DropDownComponent
                    dropName={"subject"}
                    dropValue={stateSubjects}
                    defaultValue={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? selectstateSubjects
                        : ""
                    }
                    dropSelect={setSubjectId}
                    disabled={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? false
                        : enableDisableSubjects
                    }
                    enableDisableDomains={setEnableDisableDomains}
                    languages={language}
                  ></DropDownComponent>
                </div>
              </div>
              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1"> Domain</div>
                <div className="text-sm">
                  <DropDownComponent
                    dropName={"domain"}
                    dropValue={domain}
                    defaultValue={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? selectdomain
                        : ""
                    }
                    dropSelect={SetDomainId}
                    disabled={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? false
                        : enableDisableDomains
                    }
                    enableDisableStandards={setEnableDisableStandards}
                    languages={language}
                    questionId={questionId}
                    setQuestionId={setQuestionId}
                    createQuestion={(e) =>
                      associateStandardId && createQuestion("domain", e)
                    }
                  ></DropDownComponent>
                </div>
              </div>

              <div className={"col-span-3"}>
                <div className="mb-1 text-sm text-gray-700"> Standard</div>
                <div className="text-sm">
                  <DropDownComponent
                    dropName={"standard"}
                    dropValue={standard}
                    defaultValue={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? selectstandard
                        : ""
                    }
                    dropSelect={SetStandardId}
                    disabled={
                      editFlag ||
                      copyFlag ||
                      (associateStandardId && associateStandardData)
                        ? false
                        : enableDisableStandards
                    }
                    questionId={questionId}
                    setQuestionId={setQuestionId}
                    createQuestion={(e) => createQuestion("standard", e)}
                    languages={language}
                  ></DropDownComponent>
                </div>
              </div>
              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1">
                  Ext. Source ID :
                </div>
                <div className="flex justify-between space-x-6">
                  <div className="w-2/3">
                    <Select
                      placeholder={""}
                      options={EXTERNAL_SOURCE_TYPES}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        menu: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#262626"
                              : "#262626",
                          marginTop: 0,
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                      isSearchable={false}
                      isClearable={true}
                      value={EXTERNAL_SOURCE_TYPES.filter(
                        (t) => t.value == externalSourceTypeId
                      )}
                      onChange={handleExternalSourceTypeIdChange}
                    />
                  </div>
                  <input
                    className="w-1/3 shadow appearance-none border border-gray-300 rounded-md shadow-sm py-2 px-3 text-gray-700 leading-tight focus:ring-primary-color focus:outline-none focus:shadow-outline focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
                    id="externalsourceid"
                    type="text"
                    maxLength={20}
                    placeholder="ID"
                    autoComplete={"off"}
                    value={externalSourceId}
                    onBlur={validateExternalSourceIdChange}
                    onChange={handleExternalSourceIdChange}
                  />
                </div>
              </div>
              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1">DOK</div>
                <div className="text-sm">
                  <DropDownComponent
                    dropName={"dok"}
                    dropValue={constant.DOK}
                    defaultValue={
                      (editFlag || copyFlag) &&
                      questionEditData.dok != null &&
                      questionEditData.dok > 0
                        ? selectDok
                        : ""
                    }
                    dropSelect={SetDOKId}
                  ></DropDownComponent>
                </div>
              </div>
              <div className={"col-span-3"}>
                <div className="text-sm text-gray-700 mb-1">Classification</div>
                <div className="flex justify-between space-x-6">
                  <div className="w-2/3">
                    <Select
                      placeholder={""}
                      options={questionClassification}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        menu: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#262626"
                              : "#262626",
                          marginTop: 0,
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                      isSearchable={false}
                      isClearable={true}
                      value={selectedClassification}
                      onChange={handleQuestionClassificationChange}
                    />
                  </div>
                </div>
              </div>
              {associatedPassage && associatedPassage.length > 0 && (
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">
                    Associated Passage ID :
                  </div>
                  <div className="text-sm">
                    {associatedPassage.map((passage, index) => (
                      <>
                        <a
                          key={index}
                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                          onClick={() => {
                            redirectToPassageDetail(passage.value);
                          }}
                          href={constant.EDITPASSAGE?.replace(
                            ":id",
                            passage.value ? passage.value.toString() : ""
                          )}
                        >
                          {`${passage.value} - ${passage.label}`}
                        </a>
                        {index < associatedPassage.length - 1 && <span>,</span>}
                      </>
                    ))}
                  </div>
                </div>
              )}
              {associatedVideoIds && associatedVideoIds.length > 0 && (
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">
                    Associated Video ID :
                  </div>
                  <div className="text-sm">
                    {associatedVideoIds.map((video, index) => (
                      <>
                        <a
                          key={index}
                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                          onClick={() => {
                            redirectToVideoDetail(video.associatedVideoId);
                          }}
                          href={constant.VIDEOEDIT?.replace(
                            ":id",
                            video?.associatedVideoId
                              ? video?.associatedVideoId.toString()
                              : ""
                          )}
                        >
                          {video.associatedVideoId}
                        </a>
                        {index < associatedVideoIds.length - 1 && (
                          <span>,</span>
                        )}
                      </>
                    ))}
                  </div>
                </div>
              )}

              <div className={"col-span-9 flex items-start"}>
                <label className="flex items-center pr-3">
                  <input
                    id="diagnostic"
                    name="isDiagnostic"
                    checked={isDiagnostics}
                    type="checkbox"
                    className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    onChange={() => setIsDiagnostics(!isDiagnostics)}
                  />
                  <span className="ml-2">Diagnostics</span>
                </label>
                <label className="flex items-center pr-3">
                  <input
                    id="active"
                    name="isPublished"
                    checked={isPublished}
                    type="checkbox"
                    className="focus:ring-primary-color ml-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                    onChange={() => setIsPublished(!isPublished)}
                  />
                  <span className="ml-2">Published</span>
                </label>
                <label className="flex items-center pr-3">
                  <input
                    id="active"
                    name="isMachineTranslated"
                    checked={isMachineTranslated}
                    type="checkbox"
                    className=" focus:ring-primary-color ml-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                    onChange={() =>
                      setIsMachineTranslated(!isMachineTranslated)
                    }
                    disabled={!isPublished}
                  />
                  <span className="ml-2">Auto Translate</span>
                </label>
                <label className="flex items-center pr-3">
                  <input
                    id="ai-assisted-checkbox"
                    name="isAIAssisted"
                    checked={isAIAssisted}
                    type="checkbox"
                    className=" focus:ring-primary-color ml-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                    onChange={() => setIsAIAssisted(!isAIAssisted)}
                  />
                  <span className="ml-2">AI Assisted</span>
                </label>
              </div>
            </div>

            <div className={"mt-3 grid grid-cols-12 gap-6"}></div>
          </div>
        </Tab.Panel>
        <Tab.Panel
          className={classNames(
            "bg-white text-gray-900",
            "block px-4 py-4 text-sm shadow border-b border-gray-200 sm:rounded-lg"
          )}
        >
          <QuestionStatistics
            question={questionStatistics}
          ></QuestionStatistics>
        </Tab.Panel>
        <Tab.Panel
          className={classNames(
            "bg-white",
            "block px-4 py-4 text-sm shadow border-b border-gray-200 sm:rounded-lg"
          )}
        >
          <div className={"grid grid-cols-12 gap-5"}>
            <div className={"col-span-6"}>
              <div className="text-sm">
                <TagSelector
                  label={"Tags"}
                  onTagSelectChange={(tags) => {
                    handleSaveTags(tags);
                  }}
                  removeTag={handleRemoveTag}
                  mode={TagSelectorMode.Edit}
                  categoryId={1}
                  selectedTagIds={selectedTagIds}
                />
              </div>
            </div>
          </div>
        </Tab.Panel>
        {showStandardSearchTab && (
          <Tab.Panel
            className={classNames(
              "bg-white",
              "block px-4 py-4 text-sm shadow border-b border-gray-200 sm:rounded-lg"
            )}
          >
            <div className={"grid grid-cols-12 gap-5"}>
              <div className={"col-span-12"}>
                <div className="text-sm">
                  <QuestionStandard
                    unLinkedStandardId={unLinkedStandardId}
                    questionId={questionId}
                    reloadStandards={reloadStandards}
                    stateId={selectedStateId}
                    subjectId={selectedSubjectId}
                    domainId={parseInt(selectedDomainId)}
                    contentAreaId={contentAreadId}
                    gradeLevel={gradeLevel}
                  ></QuestionStandard>
                </div>
              </div>
              {isDelink &&
                showLinkedStandards &&
                linkedStandards &&
                linkedStandards.length > 0 && (
                  <DelinkStandardPopup
                    standardId={standardToDelink}
                    title={"Linked Standards"}
                    buttonText={"Ok"}
                    confirmAction={handleDelinkConfirmation}
                    linkedStandardsData={linkedStandards}
                  />
                )}
            </div>
          </Tab.Panel>
        )}
        {editFlag && (
          <Tab.Panel
            className={classNames(
              "bg-white",
              "block px-4 py-4 text-sm shadow border-b border-gray-200 sm:rounded-lg"
            )}
          >
            <div className={"grid grid-cols-12 gap-5"}>
              <div className={"col-span-12"}>
                <TeacherFeedback
                  questionId={questionId}
                  updateQuestionFeedbackCount={updateQuestionFeedbackCount}
                />
              </div>
            </div>
          </Tab.Panel>
        )}
      </Tab.Panels>
    </Tab.Group>
  );
};

export default AuthorQuestionTabs;
